import React from 'react'

import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

import AttendeeForm from '../AttendeeForm'
import { useSignup } from './Signup.hooks'

const AttendeeDialog = ({ open, onClose, attendeeId }) => {
  const { attendees, getAttendee, addAttendee, updateAttendee } = useSignup()
  const isEditMode = attendeeId !== undefined
  const attendee = attendeeId ? getAttendee(attendeeId) : undefined
  // separate billing is possible if there exists at least one attendee who is not separatly billed
  // or editing an attendee with option already set
  const separateBillingPossible =
    attendees
      .filter((a) => a._id !== attendeeId)
      .reduce((sum, a) => (a.separateBilling ? sum : sum + 1), 0) >= 1

  const handleSubmit = (form) => {
    if (isEditMode) {
      updateAttendee(attendeeId, form)
    } else {
      addAttendee(form)
    }
    onClose()
  }
  const formId = 'add_attendee'
  return (
    <Modal
      show={open}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {isEditMode ? 'Teilnehmer bearbeiten' : 'Teilnehmer hinzufügen'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AttendeeForm
          formId={formId}
          initialState={attendee}
          onSubmit={handleSubmit}
          separateBillingPossible={separateBillingPossible}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-primary" style={{ width: '130px'}} onClick={() => onClose()}>
          Abbrechen
        </Button>
        <Button variant="primary" style={{ width: '130px'}} type="submit" form={formId}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default AttendeeDialog
